import { createSelector } from 'reselect';
import _ from 'lodash';


const getConvertedValue = (data, attribute) => {
  if (!_.isEmpty(data)) {
    return data.toJS()[attribute]
  }
  return null;
};

const selectCustomer = (state) => state.get('customer');

export const selectIsFetching = createSelector(
  selectCustomer,
  (customer) => customer.get('isFetching')
);

export const selectCustomerData = createSelector(
  selectCustomer,
  (customer) => customer.get('data')
);

export const selectCustomerContactData = createSelector(
  selectCustomer,
  (customer) => {
    const customerData = customer.get('data');
    return getConvertedValue(customerData, 'contact')
  }
);

export const selectCustomerPhoneDirectoryOwnerData = createSelector(
  selectCustomer,
  (customer) => {
    const customerData = customer.get('data');
    return getConvertedValue(customerData, 'phoneDirectoryOwnerInfo')
  }
);

export const selectCustomerDeliveryData = createSelector(
  selectCustomer,
  (customer) => {
    const customerData = customer.get('data');
    return getConvertedValue(customerData, 'delivery')
  }
);

export const selectCustomerBillingData = createSelector(
  selectCustomer,
  (customer) => {
    const customerData = customer.get('data');
    return getConvertedValue(customerData, 'billing')
  }
);

export const selectCustomerProcuraData = createSelector(
  selectCustomer,
  (customer) => {
    const customerData = customer.get('data');
    return getConvertedValue(customerData, 'procuraPersons')
  }
);

export const selectUpdateCustomerFinished = createSelector(
  selectCustomer,
  (customer) => customer.get('updateCustomerFinished')
)
